import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import classes from "./styles/style.module.css";
import { swich_Header_FooterVisibility } from "../../../assets/redux/actions/Common";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import JoftPoochLogo from "../../../assets/images/logo/joftPoochLogo.png";
import ProgressBar from "../../../assets/components/ProgressBar";
import { TypeAnimation } from "react-type-animation";
import Cube from "../../../assets/images/joftPooch/Cube.png";

const hexagons = [
  {
    id: 1,
    top: "10%",
    left: "0%",
    size: 300,
    delay: 0.2,
    yRange: 50,
    opacity: 0.3,
  },
  {
    id: 2,
    top: "35%",
    left: "60%",
    size: 100,
    delay: 0.4,
    yRange: 0,
    opacity: 0.5,
  },
  {
    id: 3,
    top: "65%",
    left: "0%",
    size: 140,
    delay: 0.6,
    yRange: 0,
    opacity: 0.2,
  },
  {
    id: 4,
    top: "70%",
    left: "20%",
    size: 300,
    delay: 0.8,
    yRange: 20,
    opacity: 0.3,
  },
  {
    id: 4,
    top: "90%",
    left: "10%",
    size: 140,
    delay: 0.8,
    yRange: 0,
    opacity: 0.6,
  },
];
function SplashScreen() {
  const dispatch = useDispatch();
  const [progressState, setProgressState] = useState(0);
  let progress = 0;

  useEffect(() => {
    dispatch(swich_Header_FooterVisibility(true));
    const interval = setInterval(() => {
      if (progress < 100) {
        progress = progress + 10;
        setProgressState(progress);
      } else {
        clearInterval(interval);
      }
    }, 300);

    return () => {
      dispatch(swich_Header_FooterVisibility(false));
      setProgressState(0);
      progress = 0;
    };
  }, []);

  return (
    <AnimatedPageContainer>
      <div className={classes.splashScreenContainer}>
        {hexagons.map((hexagon) => (
          <motion.img
            key={hexagon.id}
            src={Cube}
            alt="Hexagon"
            style={{
              position: "absolute",
              top: hexagon.top,
              left: hexagon.left,
              width: `${hexagon.size}px`,
              height: "auto",
              opacity: hexagon.opacity,
            }}
            initial={{ y: 0 }}
            animate={{
              y: hexagon.yRange !== 0 ? [0, hexagon.yRange, 0] : 0,
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "loop",
              delay: hexagon.delay,
            }}
          />
        ))}

        <motion.div
          variants={{
            hidden: { opacity: 0, y: -50, scale: 0.9 },
            visible: { opacity: 1, y: 0, scale: 1 },
          }}
          initial="hidden"
          animate="visible"
          transition={{
            duration: 0.8,
            delay: 0.2,
            type: "spring",
            stiffness: 100,
          }}
        >
          <img src={JoftPoochLogo} alt="joftPoochLogo" />
        </motion.div>

        {/* Typing Text Animation */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 1,
            delay: 1.0, // sync with logo animation
          }}
        >
          <TypeAnimation
            sequence={["در حال بارگزاری ...", 1500]}
            wrapper="p"
            speed={50}
            repeat={Infinity}
          />
        </motion.div>
        <div className={classes.progressContainer}>
          <ProgressBar
            progress={progressState}
            progressColor={"var(--sucessColor)"}
          />
        </div>
      </div>
    </AnimatedPageContainer>
  );
}

export default SplashScreen;
